module.exports = __webpack_public_path__ + "static/media/icon_ai-video-analyzer.738360ff.svg";